module.exports = __webpack_public_path__ + "static/Choose-Intermediate.8fb3bf15.svg";